<template>
  <div class="retail-hotel-index-container">
    <transition
      name="fade"
    >
      <div
        v-if="this.$store.state.hotel.retailLoading"
        class="retail-hotels-load"
      />
    </transition>
    <div class="retail-hotel-search">
      <HotelSearch />
    </div>
    <div class="retail-hotel-index">
      <div class="retail-hotel-filter-container">
        <HotelFilter />
      </div>
      <div class="retail-hotel-list">
        <div
          class="alert-container"
          :class="[ this.$store.state.hotel.hasFilterResults == false ? 'no-results' : '']"
        >
          <div class="alert-icon-container">
            <i class="fa fa-exclamation" />
          </div>
          <div class="alert-message-container">
            <div class="alert-message">
              <span>Your filter options are not showing a match.</span>
            </div>
            <div class="suggestion">
              <span>Try adjusting your filters or see more choices below.</span>
            </div>
          </div>
        </div>
        <IndexView />
        <div
          v-if="getFilteredHotels.length == 0"
          class="default-retail-list"
          :class="[ this.$store.state.hotel.showFilter == true ? 'filter-show' : '']"
        >
          <div class="overlay" />
          <RetailHotelCard
            v-for="hotel in getRetailHotels.slice(0, pageCount)"
            :key="hotel.index"
            :hotel="hotel"
            :rate="rate"
            :currency="currency"
          />
        </div>
        <div
          v-else
          class="filtered-retail-list"
          :class="[ this.$store.state.hotel.showFilter == true ? 'filter-show' : '']"
        >
          <div class="overlay" />
          <RetailHotelCard
            v-for="hotel in getFilteredHotels.slice(0, pageCount)"
            :key="hotel.index"
            :hotel="hotel"
            :rate="rate"
            :currency="currency"
          />
        </div>
        <div class="more-hotels-container">
          <div
            v-if="displayShowMore"
            class="btn btn-inverted more-retail-hotels-btn"
            @click="showMoreHotels()"
          >
            {{ $t('h4h.showMore') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './hotel_availability'
import moment from 'moment'
import HotelFilter from './retail_hotel_filter'
import HotelSearch from './hotel_search'
import IndexView from './index_view'
import RetailHotelCard from './retail_hotel_card'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  components: {
    HotelFilter,
    HotelSearch,
    IndexView,
    RetailHotelCard
  },

  mixins: [mixin],

  props:{
    rate: {
      default: 1,
      type: Number
    },
    currency: {
      default: 'USD',
      type: String
    }
  },

  computed: {
    ...mapState('hotel', {
      pageCount: state => state.pageCount
    }),
    ...mapGetters('hotel', [
      'getRetailHotels',
      'getFilteredHotels'
    ]),
    displayShowMore() {
      if (this.getFilteredHotels.length !== 0) {
        return this.pageCount < this.getFilteredHotels.length
      } else {
        return this.pageCount < this.getRetailHotels.length
      }
    }
  },

  mounted() {
    this.setRetailLoading(true)
    this.fetchAvailableHotels(
      this.$store.state.hotel.eventLatitude,
      this.$store.state.hotel.eventLongitude,
      moment(this.$store.state.hotel.checkInDate).format('YYYY-MM-DD'),
      moment(this.$store.state.hotel.checkOutDate).format('YYYY-MM-DD'),
      this.$store.state.hotel.roomQty
    )
  },

  methods:{
    ...mapMutations('hotel', ['increasePageCount']),
    showMoreHotels(){
      this.increasePageCount(10)
    }
  }
}
</script>
